var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top",style:(_vm.topStyle)},[_c('div',{staticClass:"branding"},[_c('img',{attrs:{"src":_vm.imgLink,"alt":_vm.imgAlt}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }